/**
 * Product Highlights — Carousel + Variant/Toggle (Add-to-Cart) logic
 * Copy to assets/product-highlights.js
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initAllCarousels();
    initProductHighlights();
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section) {
      initAllCarousels(section);
      initProductHighlights(section);
    }
  });

  /* ============================
     Carousel
     ============================ */
  function initAllCarousels(scope) {
    var root = scope || document;
    var carousels = root.querySelectorAll('[data-product-highlights-carousel]');
    carousels.forEach(function (el) { initCarousel(el); });
  }

  function initCarousel(container) {
    var track = container.querySelector('[data-carousel-track]');
    var slides = container.querySelectorAll('[data-carousel-slide]');
    var dots = container.querySelectorAll('[data-carousel-dot]');
    var prevBtn = container.querySelector('[data-carousel-prev]');
    var nextBtn = container.querySelector('[data-carousel-next]');

    if (!track || slides.length < 2) return;

    var current = 0;
    var total = slides.length;
    var autoplayInterval = null;
    var autoplaySpeed = parseInt(container.getAttribute('data-autoplay'), 10);

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('product-highlights-carousel__dot--active', i === current);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
        resetAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(current + 1);
        resetAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(this.getAttribute('data-carousel-dot'), 10));
        resetAutoplay();
      });
    });

    /* Touch / swipe support */
    var startX = 0;
    var deltaX = 0;

    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      deltaX = 0;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      deltaX = e.touches[0].clientX - startX;
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (Math.abs(deltaX) > 40) {
        if (deltaX < 0) goTo(current + 1);
        else goTo(current - 1);
        resetAutoplay();
      }
    });

    /* Autoplay */
    function startAutoplay() {
      if (!autoplaySpeed) return;
      autoplayInterval = setInterval(function () {
        goTo(current + 1);
      }, autoplaySpeed * 1000);
    }

    function resetAutoplay() {
      if (autoplayInterval) clearInterval(autoplayInterval);
      startAutoplay();
    }

    startAutoplay();
  }

  /* ============================
     Product Highlight — variant + toggle (add-to-cart)
     ============================ */
  function initProductHighlights(scope) {
    var root = scope || document;
    var widgets = root.querySelectorAll('.product-highlight');

    widgets.forEach(function (widget) {
      var variantSelect = widget.querySelector('[data-product-highlight-variant]');
      var toggle = widget.querySelector('[data-product-highlight-toggle]');
      var productUrl = widget.getAttribute('data-product-url');

      /* Keep track of selected variant id */
      function getVariantId() {
        if (variantSelect) return variantSelect.value;
        return widget.getAttribute('data-variant-id');
      }

      /* --- Variant change: update price & image --- */
      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          var variantId = this.value;
          widget.setAttribute('data-variant-id', variantId);
          if (!productUrl) return;

          fetch(productUrl + '.js')
            .then(function (r) { return r.json(); })
            .then(function (product) {
              var variant = product.variants.find(function (v) {
                return v.id === parseInt(variantId, 10);
              });
              if (!variant) return;

              var priceEl = widget.querySelector('.product-highlight__price');
              if (priceEl) priceEl.textContent = formatMoney(variant.price);

              var compareEl = widget.querySelector('.product-highlight__compare-price');
              if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                if (compareEl) {
                  compareEl.textContent = formatMoney(variant.compare_at_price);
                  compareEl.style.display = '';
                } else {
                  var newCompare = document.createElement('span');
                  newCompare.className = 'product-highlight__compare-price';
                  newCompare.textContent = formatMoney(variant.compare_at_price);
                  priceEl.parentNode.appendChild(newCompare);
                }
              } else if (compareEl) {
                compareEl.style.display = 'none';
              }

              if (variant.featured_image) {
                var img = widget.querySelector('.product-highlight__image');
                if (img) {
                  img.src = variant.featured_image.src;
                  img.alt = variant.featured_image.alt || product.title;
                }
              }
            })
            .catch(function (err) {
              console.error('Product Highlight: failed to fetch variant', err);
            });
        });
      }

      /* --- Toggle ON = add to cart, Toggle OFF = remove from cart --- */
      if (toggle) {
        toggle.addEventListener('change', function () {
          var variantId = getVariantId();
          if (!variantId) return;

          if (this.checked) {
            /* Add the selected variant to cart */
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
            })
              .then(function (r) { return r.json(); })
              .then(function () {
                /* Dispatch event so other scripts (e.g. cart drawer) can react */
                document.dispatchEvent(new CustomEvent('product-highlight:added', {
                  detail: { variantId: variantId }
                }));

                /* Optionally refresh cart count in header */
                refreshCartCount();
              })
              .catch(function (err) {
                console.error('Product Highlight: add to cart failed', err);
                toggle.checked = false;
              });
          } else {
            /* Remove item from cart by setting quantity to 0 */
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId.toString(), quantity: 0 })
            })
              .then(function (r) { return r.json(); })
              .then(function () {
                document.dispatchEvent(new CustomEvent('product-highlight:removed', {
                  detail: { variantId: variantId }
                }));
                refreshCartCount();
              })
              .catch(function (err) {
                console.error('Product Highlight: remove from cart failed', err);
                toggle.checked = true;
              });
          }
        });
      }
    });
  }

  /* --- Refresh the cart item count badge (works with most themes) --- */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-cart-count], .cart-count-bubble span');
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var amount = (cents / 100).toFixed(2);
    var symbol = '$';
    var metaEl = document.querySelector('meta[itemprop="priceCurrency"]');
    if (metaEl) {
      var currency = metaEl.getAttribute('content');
      var symbols = { USD: '$', EUR: '€', GBP: '£', CAD: 'CA$', AUD: 'A$', JPY: '¥' };
      symbol = symbols[currency] || currency + ' ';
    }
    return symbol + amount;
  }
})();